<div class="TotemProduct pt-2">
    @if(isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @else {
        <app-ef-product [productData]="productData" [oneColumn]="true"></app-ef-product>
    }
</div>
